import React from "react";
import { Button, Dropdown, Spinner } from "react-bootstrap";
import { Plus } from "react-bootstrap-icons";
import "./webReportEdit.css";

const NEW_ITEM_TYPES = ["Info", "Issue", "Overview", "Limit"];

const formatAddress = (address) => {
  if (!address) return "";
  if (address.formatted_address) return address.formatted_address;
  return [
    address.address_line1,
    address.address_line2,
    address.city,
    address.state,
    address.zip_code,
  ]
    .filter(Boolean)
    .join(", ");
};

const EditHeader = ({
  address,
  coverImageUrl,
  scrolledPastCover = false,
  onSelectNewItemType,
  onCompile,
  newItemLoading = false,
  compileLoading = false,
}) => {
  const formattedAddress = formatAddress(address);
  const isNewItemDisabled = !onSelectNewItemType || newItemLoading;
  const isCompileDisabled = !onCompile || compileLoading;

  const showCoverBg = scrolledPastCover && !!coverImageUrl;

  const headerStyle = showCoverBg
    ? { backgroundImage: `url(${coverImageUrl})` }
    : undefined;

  return (
    <div
      className={`edit-header ${showCoverBg ? "scrolled" : ""}`}
      style={headerStyle}
    >
      {showCoverBg && <div className="edit-header-mask" />}
      <div className="edit-header-inner">
        <div className="edit-header-title-section">
          <div className="edit-header-label">Inspection Results</div>
          <h1 className="edit-header-address">{formattedAddress}</h1>
        </div>
        <div className="edit-header-actions">
          <Dropdown>
            <Dropdown.Toggle
              as={Button}
              variant="outline-primary"
              size="sm"
              className="edit-header-new-item-btn"
              disabled={isNewItemDisabled}
            >
              <Plus size={18} />
              New Item
            </Dropdown.Toggle>
            <Dropdown.Menu align="end">
              {NEW_ITEM_TYPES.map((type) => (
                <Dropdown.Item
                  key={type}
                  onClick={() =>
                    onSelectNewItemType && onSelectNewItemType(type)
                  }
                >
                  {type}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
          <Button
            variant="primary"
            size="sm"
            onClick={onCompile}
            disabled={isCompileDisabled}
            className="edit-header-compile-btn"
          >
            {compileLoading ? (
              <>
                <Spinner animation="border" size="sm" /> Compiling...
              </>
            ) : (
              "Compile Report"
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EditHeader;
